import { Injectable, Pipe } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BankModel } from '../models/bank.model';

@Pipe({ name: 'BankService' })
@Injectable()
export class BankService {

  constructor(private httpClient: HttpClient) { }

  createBank(bankAccount: BankModel) {
      let url = localStorage.getItem('ApiEndPoint') + "/api/bankAccount/createBankAccount";
      return this.httpClient.post(url, { BankAccount: bankAccount })
      .map((response: Response) => {
        return response;
      });
  }

  editBankById(bankAccount: BankModel, userId: string) {
      let url = localStorage.getItem('ApiEndPoint') + "/api/bankAccount/editBankAccount";
      return this.httpClient.post(url, { BankAccount: bankAccount, UserId: userId })
      .map((response: Response) => {
        return response;
      });
  }

  deleteBankById(bankId: string) {
      let url = localStorage.getItem('ApiEndPoint') + "/api/bankAccount/deleteBankAccount";
      return this.httpClient.post(url, { BankAccountId: bankId })
      .map((response: Response) => {
        return response;
      });
  }

  getBankById(bankId: string) {
      let url = localStorage.getItem('ApiEndPoint') + "/api/bankAccount/getBankAccountById";
      return this.httpClient.post(url, { BankAccountId: bankId })
      .map((response: Response) => {
        return response;
      });
  }

  getAllBankAccountByObject(objectId: string, objectType: string) {
      let url = localStorage.getItem('ApiEndPoint') + "/api/bankAccount/getAllBankAccountByObject";
      return this.httpClient.post(url, { objectId: objectId, ObjectType: objectType })
      .map((response: Response) => {
        return response;
      });
  }

  getCompanyBankAccount(userId: string) {
      let url = localStorage.getItem('ApiEndPoint') + "/api/bankAccount/getCompanyBankAccount";
      return this.httpClient.post(url, { UserId: userId })
          .map((response: Response) => {
              return response;
          });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/bank.service.ts